export const MODULE_NAME = "assessment-plan-query";
